
export default "/assets/cog-6-tooth-micro.014464d7.svg"